// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__151hp","footer":"ModalInfo_footer__dl607"};